import * as React from 'react';

interface IProps {
  details: any;
}

export default function UserEmailAddress(props: IProps) {
  const emailAddress = props.details &&
    props.details.identities &&
    props.details.identities.find((i: any) => i.claims.email).claims.email;
  return <div>{emailAddress}</div>;
}



// WEBPACK FOOTER //
// ./src/components/ConfirmPurchase/UserEmailAddress.tsx